__webpack_require__.p = "/chessanalyser/";